import { useCallback, useEffect, useState } from 'react';

import { useGetCandidatesFilters } from 'src/pages/CancellationsPage/api';

import {
  useGetCityIdOptions,
  useGetJobTypeIdOptions,
  useGetLanguageIdOptions,
  useGetCertificatesIdOption,
  useGetUserStatusIdOptions,
} from 'src/pages/CandidatesPage/api';
import AdvancedFilters, {
  AdvancedFiltersProps,
  AdvancedFiltersState,
} from 'src/components/AdvancedFilters';

export default function CandidatesFilters({
  open,
  handleSearch,
  filters,
}: AdvancedFiltersProps) {
  const [advancedFilters, setAdvancedFilters] = useState<
    AdvancedFiltersState[]
  >([{}]);

  useEffect(() => {
    setAdvancedFilters(filters.length ? filters : [{}]);
  }, [open, filters]);

  const { data } = useGetCandidatesFilters({ enabled: open });
  const { data: cities } = useGetCityIdOptions({ enabled: open });
  const { data: jobTypes } = useGetJobTypeIdOptions({ enabled: open });
  const { data: languages } = useGetLanguageIdOptions({ enabled: open });
  const { data: certificates } = useGetCertificatesIdOption({
    enabled: open,
  });
  const { data: userStatuses } = useGetUserStatusIdOptions({
    enabled: open,
  });

  const dynamicOptions = useCallback(
    (options: { version: string; uri: string }) => {
      if (options.uri === '/cities') {
        return cities;
      }
      if (options.uri === '/job_types') {
        return jobTypes;
      }
      if (options.uri === '/languages') {
        return languages;
      }
      if (options.uri === '/certificates') {
        return certificates;
      }
      if (options.uri === '/user_statuses') {
        return userStatuses;
      }
    },
    [jobTypes, cities, languages, certificates, userStatuses],
  );

  return (
    <AdvancedFilters
      open={open}
      data={data}
      filters={advancedFilters}
      handleSearch={handleSearch}
      setFilters={setAdvancedFilters}
      dynamicOptions={dynamicOptions}
    />
  );
}
